export default __webpack_public_path__ + "static/media/bell.249d15b8.png";